import React, { useContext, useEffect, useState } from 'react';
import { Button, Typography, MenuItem, Grid, Box, Card, TextField, FormControl, Select, Chip } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { ProviderServices } from '../CrudServices';
import { UrbanTypeServices } from '../../Settings/Subscription/UrbanType/UrbanTypeServices';

export default function PersonalDetails({ personalDetails }) {
  
  const [providerPersonalDetails, setProviderPersonalDetails] = useState(
    {
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      dob: '',
      mobileNumber: '',
      serviceCategories: [],
      waiveVisitCharge: 0,
      gender: '',
      image: '',
    }
  );
  useEffect(() => {
    if (personalDetails) {
      // console.log("personal details:",personalDetails)
      setProviderPersonalDetails(pre => ({ ...pre, ...personalDetails }))
    }
  }, [personalDetails])
  return (
    <Grid item xs={12}>
      <Card>
      <Box sx={{ p: '.5% 2%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
        <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Personal Info</Typography>
      </Box>
      <Grid container spacing={1} sx={{p:'2%'}}>
        <Grid item xs={12} sm={3}>
          <Typography sx={{  fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Full Name</Typography>
          <TextField
            sx={{}}
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
            fullWidth
            size='small'
            value={`${providerPersonalDetails.firstName ? providerPersonalDetails.firstName : ''} ${providerPersonalDetails.middleName ? providerPersonalDetails.middleName : ''} ${providerPersonalDetails.lastName ? providerPersonalDetails.lastName : ''}`}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography sx={{  fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Email</Typography>
          <TextField
            fullWidth
            // sx={{width:'80%'}}
            size='small'
            value={providerPersonalDetails.email || ''}
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2.5}>
          <Typography sx={{ width: '65%', fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Primary Contact</Typography>
          <TextField
            // sx={{width:'58%'}}
            fullWidth
            size='small'
            value={providerPersonalDetails.mobileNumber}
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2.5}>
          <Typography sx={{ width: '65%', fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Alternate Contact </Typography>
          <TextField
            // sx={{width:'58%'}}
            fullWidth
            size='small'
            value={providerPersonalDetails?.mobileNumberAlt}
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography sx={{  fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Date Of Birth</Typography>
          <TextField
            size='small'
            fullWidth
            value={providerPersonalDetails.dob ? dayjs(providerPersonalDetails.dob).format('DD-MM-YYYY') : ''}
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography sx={{  fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Gender </Typography>
          <TextField
            size='small'
            fullWidth
            value={providerPersonalDetails.gender || ''}
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography sx={{ fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Visiting Charge </Typography>
          <TextField
            value={providerPersonalDetails?.visitingCharge || ''}
            size='small'
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography sx={{ fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>waive Visit Charge </Typography>
          <TextField
            value={providerPersonalDetails.waiveVisitCharge || ''}
            size='small'
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Service Categories </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, border: '1px solid lightGray', p: '1%', borderRadius: '.25rem', minHeight: '2.5rem' }}>
            {(providerPersonalDetails.serviceCategories).length>0 &&providerPersonalDetails.serviceCategories.map(category => {
              // const category = categoryList.find(opt => opt.id == id);
              // if (category) {
                return (
                  <Chip
                    key={category.id}
                    label={category.proServCat.title}
                    color="primary"
                    variant="outlined"
                    size="small"
                    sx={{ fontSize: '.65rem' }}
                  />
                );
              // }
              // return null;
            })}
          </Box>
        </Grid>
        <Grid item xs={12} >
          <Typography sx={{ fontWeight: '600', texttTransform: 'uppercase', fontSize: '.75rem' }}>Description </Typography>
          <TextField
            value={providerPersonalDetails.description || ''}
            size='small'
            fullWidth
            multiline
            rows={3}
            disabled
            inputProps={{
              style: { fontSize: '.75rem' }
            }}
          />
        </Grid>
      </Grid>
      </Card>
    </Grid>
  );
}
